import type { ActionModel } from '@jet/environment/types/models';
import type { Opt } from '@jet/environment/types/optional';
import type { Lockup } from '../Lockup';
import type { Link } from './../../page';
import type { ContentKind } from '../../content-descriptor/ContentKind';

export type TrackLockupLayoutKind =
    | 'shelfTrackList'
    | 'albumTrackList'
    | 'playlistTrackList'
    | 'recordingTrackList'
    | 'compilationTrackList';

export type TrackLockupLayoutStyle =
    | TrackLockupLayoutStyleAlbumTrackList
    | TrackLockupLayoutStylePlaylistTrackList
    | TrackLockupLayoutStyleRecordingTrackList
    | TrackLockupLayoutStyleCompilationTrackList
    | 'shelfTrackList';

export interface TrackLockupLayoutStyleAlbumTrackList {
    kind: 'albumTrackList';
    readonly hasVideo: boolean;
}

export interface TrackLockupLayoutStylePlaylistTrackList {
    kind: 'playlistTrackList';
    readonly hasVideo: boolean;
    readonly hasBadging: boolean;
}

export interface TrackLockupLayoutStyleRecordingTrackList {
    kind: 'recordingTrackList';
    readonly hasVideo: boolean;
}

export interface TrackLockupLayoutStyleCompilationTrackList {
    kind: 'compilationTrackList';
    readonly hasVideo: boolean;
}

export interface TrackLockup extends Lockup {
    headline?: Opt<string>;
    subtitleLinks?: Opt<Link[]>;
    trackNumber?: Opt<number>;
    tertiaryLinks?: Opt<Link[]>;
    duration?: Opt<number>;
    showPopularityIndicator?: Opt<boolean>;
    showExplicitBadge?: Opt<boolean>;
    layoutStyle: TrackLockupLayoutStyle;
    type: ContentKind;
    // Default value is false
    isProminent?: Opt<boolean>;
    rankingText?: Opt<string>;
    pauseAction?: Opt<ActionModel>;
    resumeAction?: Opt<ActionModel>;
    // Default value is false
    isDisabled?: Opt<boolean>;
    // Default value is false
    isPreviewMode?: Opt<boolean>;
    workName?: Opt<string>;
    isSectionGrouped?: Opt<boolean>;
    composer?: Opt<string>;
    discNumber?: Opt<number>;
    openContextualMenuAction?: Opt<ActionModel>;
    artistName?: Opt<string>;
    previewUrl?: Opt<string>;
}

export function trackLockupLayoutStyle(
    isForColumnStyleTracklist: boolean,
    hasVideo = false,
    hasBadging = false,
): TrackLockupLayoutStyle {
    if (isForColumnStyleTracklist) {
        return {
            kind: 'playlistTrackList',
            hasVideo,
            hasBadging,
        };
    }

    return 'shelfTrackList';
}
